import { cn } from "@/lib/utils";

export function Checkbox({
  id,
  name,
  checked,
  onChange,
  error,
  describedBy,
}: {
  id: string;
  name: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  error?: string;
  describedBy?: string;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start gap-3">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          aria-required="true"
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy ?? (error ? `${id}-error` : undefined)}
          className={cn(
            "mt-0.5 h-5 w-5 shrink-0 rounded-xs border border-line-strong bg-white",
            "accent-clay focus-visible:outline-2 focus-visible:outline-clay focus-visible:outline-offset-2",
          )}
        />
        <label htmlFor={id} className="font-sans text-sm text-ink-soft">
          Souhlasím se zpracováním údajů za účelem vyřízení poptávky.
          <span aria-hidden="true" className="ml-1 text-clay">
            *
          </span>
        </label>
      </div>
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-sm text-clay-dark">
          {error}
        </p>
      ) : null}
    </div>
  );
}
